import { 
    FETCH_AVAILABLE_OPTIONS_TICKERS_START,
    FETCH_AVAILABLE_OPTIONS_TICKERS_SUCCESS,
    FETCH_AVAILABLE_OPTIONS_TICKERS_FAILURE,
} from "../actions/availableOptionTickersAction";

const initialState = {
    availableOptionsTickers: {},
    fetchedDate: null,
};

export const availableOptionsTickersReducer = (state = initialState, action) => {
    switch (action.type){
        case FETCH_AVAILABLE_OPTIONS_TICKERS_START:
            return { ...state, isLoading: true, error: null };
        case FETCH_AVAILABLE_OPTIONS_TICKERS_SUCCESS:
            return { ...state, isLoading: false, availableOptionsTickers: action.payload.details.result, fetchedDate: action.payload.fetchedDate, error: null };
        case FETCH_AVAILABLE_OPTIONS_TICKERS_FAILURE:
            return { ...state, isLoading: false, error: action.payload.error};
        default:
            return state;
    }
}

export default availableOptionsTickersReducer